import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { TAG_RELATED_ITEM_TYPE } from '../../constants/service/app/tagConstants';
import { appActions } from '../../store/modules/app';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { tagActions } from '../../store/modules/tag';
import { TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL } from '../../store/modules/tag/models';
import TagHistoryWrap from '../../views/tag/history/TagHistorylWrap';

class TagHistoryContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  initiate = (tagId) => {
    const { getTagHistory } = this.props;
    getTagHistory({
      tagId,
      relatedItemList: {
        /**
         *  상품
         */
        [TAG_RELATED_ITEM_TYPE.PRODUCT]: {
          searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        },
        /**
         *  브랜드
         */
        [TAG_RELATED_ITEM_TYPE.STORE]: {
          searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        },
        /**
         *  기획전
         */
        [TAG_RELATED_ITEM_TYPE.EVENT]: {
          searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        },
        /**
         *  상품 후기
         */
        [TAG_RELATED_ITEM_TYPE.REVIEW]: {
          searchOption: TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        },
      },
    });
  };

  /**
   *  태그 상세 내역에 연결된 아이템 리스트 불러오기
   */
  getTagHistoryRelatedItemList = (option) => {
    const { getTagHistoryRelatedItemList, tagHistory } = this.props;
    const { tagInfo, relatedItemList } = tagHistory;
    const { searchOption, pagination } = relatedItemList[option.tagRelatedItemType];

    getTagHistoryRelatedItemList({
      tagId: tagInfo.tagId,
      searchOption,
      pagination,
      ...option,
    });
  };

  render() {
    const { tagHistory, setData, getTagPreviewData, getProductSubCategoryList } = this.props;

    return (
      <TagHistoryWrap
        setData={setData}
        tagHistory={tagHistory}
        getTagHistoryRelatedItemList={this.getTagHistoryRelatedItemList}
        getTagPreviewData={getTagPreviewData}
        getProductSubCategoryList={getProductSubCategoryList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagHistory: state.tag.tagHistory,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  getTagHistory: tagActions.getTagHistory,
  getTagHistoryRelatedItemList: tagActions.getTagHistoryRelatedItemList,
  getTagPreviewData: appActions.getTagPreviewData,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TagHistoryContainer));
